import styled from 'styled-components';
import Modal from '../../../components/Modal';
import { BodyLarge, ParagraphLargeText } from '../../../components/Texts';
import Button from '../../../components/Button';
import LoadingCircle from '../../../components/LoadingCircle';
import { selectSolanaUSDCBalance } from '../../../redux/slices/walletSlice';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useSolana } from '../../../hooks/useSolana';

const ContentContainer = styled.div`
  width: 100%;
  overflow: hidden;

  .stripe-onramp-container {
    min-height: 300px;
    iframe {
      height: 500px !important;
      min-height: unset !important;
      max-height: 500px !important;
      aspect-ratio: unset !important;
    }
  }
`;

const StyledModal = styled(Modal)`
  .modal-content {
    overflow: hidden;
    max-height: 700px;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 16px;
`;

const LoadingContainer = styled.div`
  width: 100%;
  display: flex;
  padding-top: 20px;
  padding-bottom: 20px;
  justify-content: center;
  align-items: center;
`;

const DetectDeposit = ({ onClose, initialBalance }) => {
  const usdcBalance = useSelector(selectSolanaUSDCBalance);
  const { refreshTokenBalances } = useSolana();

  useEffect(() => {
    const interval = setInterval(async () => {
      await refreshTokenBalances();
    }, [1000]);
    return () => {
      clearInterval(interval);
    };
  }, [refreshTokenBalances]);

  useEffect(() => {
    if (usdcBalance > initialBalance) {
      onClose();
    }
  }, [usdcBalance]);

  return (
    <StyledModal onClose={onClose}>
      <ContentContainer>
        <ParagraphLargeText>Detecting your deposit</ParagraphLargeText>
        <BodyLarge>We are detecting your deposit. Please wait</BodyLarge>
        <LoadingContainer>
          <LoadingCircle />
        </LoadingContainer>
        <ButtonContainer>
          <Button onClick={() => onClose()} fullWidth={true}>
            Continue
          </Button>
        </ButtonContainer>
      </ContentContainer>
    </StyledModal>
  );
};

export default DetectDeposit;
